import axios from "axios";
import Cookies from "js-cookie";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Get the current status of the chatbot
 * @returns {Promise<Object>} The chatbot status with enabled flag
 */
export const getChatStatus = async () => {
    return axios.get(
        `${API_BASE_URL}/api/ai-chat/status`,
        {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                Authorization: `Bearer ${Cookies.get("authToken")}`,
            },
        }
    );
};

/**
 * Send a chat message to the AI assistant
 * @param {string} message - The user's message
 * @param {string} conversationId - The conversation ID to maintain context (optional)
 * @returns {Promise<Object>} The chat response
 */
export const sendChatMessage = async (message, conversationId = null) => {
    const token = Cookies.get("authToken");
    const officeCode = Cookies.get("officeCodes");

    if (!token) {
        throw new Error("Authentication token not found. Please log in again.");
    }

    if (!officeCode) {
        throw new Error("Office code not found. Please contact support.");
    }

    const requestBody = { message };
    // Include conversationId if provided (for maintaining conversation history)
    if (conversationId) {
        requestBody.conversationId = conversationId;
    }

    return axios.post(
        `${API_BASE_URL}/api/ai-chat/chat`,
        requestBody,
        {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
                "Office-Code": officeCode,
                "Accept": "application/json",
            },
        }
    );
};

export default sendChatMessage;
